/**
 * Plan-tier predicate. Single source of truth for paid-only feature gates.
 *
 * Fix prompts (the copy-ready, peer-grounded fix for each finding) are a paid
 * feature; findings, scores, and dominant patterns stay free on every plan. The
 * client gates the local fix-prompt surfaces on this; the `/v1/fix-prompts` route
 * is the authoritative server-side backstop (require_paid).
 */
export type Plan = "free" | "pro" | "enterprise";

export function isPaidPlan(plan?: Plan | null): boolean {
  return plan === "pro" || plan === "enterprise";
}

/**
 * Single source of truth for the peer-grounded (corpus percentile) capability;
 * consumed by BOTH the CLI render path and the MCP tools so they never diverge
 * (plan §1.5). The percentile itself is a pure, local, free computation — only
 * surfacing it is paid. Mirrors `isPaidPlan` so the gate can never drift from
 * the canonical paid-plan definition.
 */
export function isPeerGroundedEntitled(plan?: Plan | string | null): boolean {
  return isPaidPlan(plan as Plan | null | undefined);
}
